// @ts-nocheck



import CommonApi from '../commonApi';
import { fetchRequest } from './';

const basedUrl = '/oilsAndFluidsConsumptionPlanVehicle';
const oilsAndFluidsConsumptionPlanVehicle = new CommonApi(
  basedUrl,
  'план расхода для ТС'
);

export default {
  ...oilsAndFluidsConsumptionPlanVehicle,
  vehiclePlan: async (
  vehicleId,
  period) =>
  {
    const result = await fetchRequest.get(
      `${basedUrl}/${vehicleId}/${period}`
    );
    if (result) return result;
    throw new Error('Не удалось загрузить план расхода для ТС');
  }
};
